const PREFIX = "one-time-promise";

export const DATA_TEST_IDS = {
    FTUE_BOTTOMSHEET: `${PREFIX}-ftue-bottomsheet`,
    FTUE_BOTTOMSHEET_CLOSE_BUTTON: `${PREFIX}-ftue-bottomsheet-close-button`,
    FTUE_BOTTOMSHEET_BENEFITS_IMAGE: `${PREFIX}-ftue-bottomsheet-benefits-image`,
    FTUE_BOTTOMSHEET_CTA_CONTAINER: `${PREFIX}-ftue-bottomsheet-cta-container`,
    CROUTON: `${PREFIX}-crouton`,
    CROUTON_LOGO: `${PREFIX}-crouton-logo`,
    CROUTON_TITLE: `${PREFIX}-crouton-title`,
    CROUTON_CLOSE_BUTTON: `${PREFIX}-crouton-close-button`,
};
